import React from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import NotFound from "./pages/NotFound/NotFound";
import LoggingInPage from "./pages/onboarding/LoggingInPage/LoggingInPage";
import { ProtectedRoute } from "./components/ProtectedRoute/ProtectedRoute";
import { ROUTES } from "./utils/constants";
import PaymentConfirmation from "./pages/payments/PaymentConfirmation/PaymentConfirmation";
import PaymentConfirmationStatus from "./pages/payments/PaymentConfirmationStatus/PaymentConfirmationStatus";
import PaymentInitiationMobile from "./pages/payments/PaymentInitiationMobile/PaymentInitiationMobile";
import PaymentPendingMobile from "./pages/payments/PaymentPendingMobile/PaymentPendingMobile";
import PaymentSuccessfulMobile from "./pages/payments/PaymentSuccessfulMobile/PaymentSuccessfulMobile";
import PaymentFailedMobile from "./pages/payments/PaymentFailedMobile/PaymentFailedMobile";
import GamesPage from "./pages/GamesPage/GamesPage";
import PlayGame from "./pages/PlayGame/PlayGame";
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import AppLayout from "./components/layouts/AppLayout/AppLayout";
import GameLandingPage from "./pages/GameLandingPage/GameLandingPage";
import Wallet from "./pages/Wallet/Wallet";
import Friends from "./pages/Friends/Friends";
import Topup from "./pages/topup/Topup/Topup";
import TopupPending from "./pages/topup/TopupPending/TopupPending";
import TopupSuccessful from "./pages/topup/TopupSuccessful/TopupSuccessful";
import TopupFailed from "./pages/topup/TopupFailed/TopupFailed";
import TransactionDetails from "./pages/TransactionDetails/TransactionDetails";
import { handleGetMyTransactionDetails } from "./api-clients/walletsTransactionsClient";
import GameFlowPage from "./pages/GameFlowPage/GameFlowPage";
import SignUpStartFlowPage from "./pages/SignUpStartFlowPage/SignUpStartFlowPage";
import SignUpWelcomeFlowPage from "./pages/SignUpWelcomeFlowPage/SignUpWelcomeFlowPage";
import LoginStartFlowPage from "./pages/LoginStartFlowPage/LoginStartFlowPage";
import LoginWelcomeFlowPage from "./pages/LoginWelcomeFlowPage/LoginWelcomeFlowPage";
import Genres from "./pages/Genres/Genres";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import ConnectAccountsConfirmation from "./pages/payments/ConnectAccountsConfirmation/ConnectAccountsConfirmation";
import DownloadPageTemplate from "./pages/DownloadPage/DownloadPage";
import { LandingPageVariants } from "./utils/constants";
import KycSubmitted from "./pages/kyc/KycSubmitted/KycSubmitted";

const router = createBrowserRouter([
  {
    path: "",
    element: <AppLayout />,
    children: [
      {
        path: ROUTES.ROOT.DASHBOARD,
        element: (
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.ROOT.HOME,
        element: <GamesPage />,
      },
      {
        path: ROUTES.GAMES.ROOT,
        element: <GamesPage />,
      },
      {
        path: ROUTES.GAMES.PENDING,
        element: <GamesPage />,
      },
      {
        path: ROUTES.GAMES.GAME_REQUESTS,
        element: <GamesPage />,
      },
      {
        path: ROUTES.GAMES.LIVE_GAMES,
        element: <GamesPage />,
      },
      {
        path: ROUTES.GAMES.FAVORITES,
        element: <GamesPage />,
      },
      {
        path: ROUTES.GAMES.GAME,
        element: <GamesPage />,
      },
      {
        path: ROUTES.GAMES.GENRE_SEO,
        element: <Navigate to={ROUTES.GAMES.ROOT} replace />,
      },
      {
        path: ROUTES.GAMES.SUB_GENRE_SEO,
        element: <Navigate to={ROUTES.GAMES.ROOT} replace />,
      },
      {
        path: ROUTES.DOWNLOAD.ROOT,
        element: <DownloadPageTemplate variant={LandingPageVariants.DEFAULT} />,
      },
      {
        path: `${ROUTES.DOWNLOAD.ROOT}/${ROUTES.DOWNLOAD.START_DOWNLOAD}`,
        element: <Navigate to={ROUTES.DOWNLOAD.ROOT} replace />,
      },
      {
        path: ROUTES.GAMES.GENRES,
        element: <Genres />,
      },
      {
        path: ROUTES.GAMES.GENRE,
        element: <Genres />,
      },
      {
        path: ROUTES.GAMES.GAME_LANDING_PAGE,
        element: <GameLandingPage />,
      },
      {
        path: `${ROUTES.GAMES.ROOT}/:gameSlug${ROUTES.GAMES.PLAY_GAME}`,
        element: (
          <ProtectedRoute>
            <PlayGame />
          </ProtectedRoute>
        ),
      },
      {
        path: `${ROUTES.GAMES.ROOT}/:gameSlug/:tournamentId`,
        element: <GameFlowPage />,
      },
      {
        path: ROUTES.WALLET.ROOT,
        element: (
          <ProtectedRoute>
            <Wallet />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.ROOT.FRIENDS,
        element: <Friends />,
      },
      {
        path: ROUTES.ROOT.PROFILE,
        element: (
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.WALLET.TOPUP,
        element: (
          <ProtectedRoute>
            <Topup />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.WALLET.INITIATE_PAYMENT,
        element: <PaymentInitiationMobile />,
      },
      {
        path: ROUTES.WALLET.CONFIRM_PAYMENT,
        element: <PaymentConfirmation />,
      },
      {
        path: ROUTES.WALLET.PAYMENT_STATUS,
        element: (
          <ProtectedRoute>
            <PaymentConfirmationStatus />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.WALLET.PAYMENT_PENDING_MOBILE,
        element: <PaymentPendingMobile />,
      },
      {
        path: ROUTES.WALLET.PAYMENT_SUCCESSFUL_FIRST_MOBILE,
        element: <PaymentSuccessfulMobile />,
      },
      {
        path: ROUTES.WALLET.PAYMENT_SUCCESSFUL_RETURN_MOBILE,
        element: <PaymentSuccessfulMobile />,
      },
      {
        path: ROUTES.WALLET.PAYMENT_FAILED_MOBILE,
        element: <PaymentFailedMobile />,
      },
      {
        path: ROUTES.WALLET.TOPUP_PENDING,
        element: (
          <ProtectedRoute>
            <TopupPending />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.WALLET.TOPUP_SUCCESSFUL_FIRST,
        element: (
          <ProtectedRoute>
            <TopupSuccessful />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.WALLET.TOPUP_SUCCESSFUL_RETURN,
        element: (
          <ProtectedRoute>
            <TopupSuccessful />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.WALLET.TOPUP_FAILED,
        element: (
          <ProtectedRoute>
            <TopupFailed />
          </ProtectedRoute>
        ),
      },
      {
        path: `${ROUTES.WALLET.TRANSACTION_HISTORY}/:transactionId`,
        element: (
          <ProtectedRoute>
            <TransactionDetails />
          </ProtectedRoute>
        ),
        loader: async ({ params }) => {
          const transactionDetails = await handleGetMyTransactionDetails(
            params.transactionId as string
          );
          if (!transactionDetails) {
            throw new Response("Transaction details not found", {
              status: 404,
            });
          }
          return transactionDetails;
        },
        errorElement: <NotFound />,
      },
      {
        path: ROUTES.WALLET.CONNECT_ACCOUNTS_CONFIRMATION,
        element: <ConnectAccountsConfirmation />,
      },
      {
        path: ROUTES.ROOT.SIGN_UP,
        children: [
          {
            path: "",
            element: <SignUpStartFlowPage />,
          },
          {
            path: ROUTES.SIGN_UP.WELCOME,
            element: (
              <ProtectedRoute>
                <SignUpWelcomeFlowPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: ROUTES.ROOT.LOG_IN,
        children: [
          { path: "", element: <LoginStartFlowPage /> },
          {
            path: ROUTES.LOG_IN.WELCOME,
            element: (
              <ProtectedRoute>
                <LoginWelcomeFlowPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: ROUTES.ROOT.LOGGING_IN,
        element: <LoggingInPage />,
      },
      {
        path: ROUTES.KYC.SUBMITTED,
        element: <KycSubmitted />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

export default router;
